// extracted by mini-css-extract-plugin
export default {"inputWrapper":"StripeInput_inputWrapper__ZmbSz"};